'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _typeof = require('./../../external/@babel/runtime/helpers/esm/typeof.js');
var slicedToArray = require('./../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var PropTypes = require('prop-types');
require('../Alert/Alert.js');
require('../Article/Article.js');
require('../ArticleInfoBlock/ArticleInfoBlock.js');
require('../Banner/Banner.js');
require('../BreadCrumbs/BreadCrumbs.js');
require('../ErrorPage/ErrorPage.js');
require('../FeatureCarousel/FeatureCarousel.js');
require('../FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');
require('../FeaturedMarquee/FeaturedMarquee.js');
require('../NewsletterSubscription/NewsletterSubscription.js');
require('../OurTeam/OurTeam.js');
require('../PageHeader/PageHeader.js');
require('../Pagination/Pagination.js');
var PaginationContainer = require('../PaginationContainer/PaginationContainer.js');
require('../PanelGroup/PanelGroup.js');
require('../PanelGroup/Panel/Panel.js');
require('../PodcastCarousel/PodcastCarousel.js');
require('../SecondaryNav/SecondaryNav.js');
require('../Section/Section.js');
require('../Section/SectionHeader/SectionHeader.js');
require('../SplitBanner/SplitBanner.js');
require('../SplitBanner/SplitBannerImage/SplitBannerImage.js');
require('../SplitBanner/SplitBannerVideo/SplitBannerVideo.js');
require('../SplitBanner/SplitBannerContent/SplitBannerContent.js');
require('../SplitBanner/SplitBannerContact/SplitBannerContact.js');
var Button = require('../../primitives/Button/Button.js');
require('../../primitives/Hero/Hero.js');
require('../../primitives/HeroSrcSet/HeroSrcSet.js');
require('../../primitives/Icon/Icon.js');
require('../../primitives/Link/Link.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var OpenPositions = function OpenPositions(_ref) {
  var id = _ref.id,
    backgroundColor = _ref.backgroundColor,
    jobs = _ref.jobs,
    link = _ref.link,
    linkText = _ref.linkText,
    pageSize = _ref.pageSize,
    header = _ref.header,
    isLinkable = _ref.isLinkable;
  var _useState = React.useState(jobs),
    _useState2 = slicedToArray.default(_useState, 2),
    pastJobsDisplay = _useState2[0],
    setJobsDisplay = _useState2[1];
  if (jobs.length) {
    return /*#__PURE__*/React__default.default.createElement(PaginationContainer.PaginationContainer, {
      backgroundColor: backgroundColor,
      className: "positions-section",
      data: jobs,
      setDataDisplay: setJobsDisplay,
      header: header,
      link: link,
      linkText: linkText,
      pageSize: pageSize,
      scrollId: id,
      isLinkable: isLinkable
    }, /*#__PURE__*/React__default.default.createElement("div", {
      className: "positions-grid"
    }, pastJobsDisplay.map(function (_ref2, index) {
      var title = _ref2.title,
        url = _ref2.url;
      return /*#__PURE__*/React__default.default.createElement("div", {
        className: "positions-card",
        key: "positions-card-".concat(index)
      }, /*#__PURE__*/React__default.default.createElement("div", {
        className: "position-title"
      }, title), /*#__PURE__*/React__default.default.createElement(Button.Button, {
        target: "_blank",
        href: url,
        outline: true,
        color: "secondary"
      }, "LEARN MORE"));
    })));
  }
};
OpenPositions.defaultProps = {
  id: 'open-positions',
  isLinkable: false,
  jobs: [],
  pageSize: 12
};
OpenPositions.propTypes = {
  jobs: PropTypes__default.default.array.isRequired,
  backgroundColor: PropTypes__default.default.string,
  className: PropTypes__default.default.string,
  header: PropTypes__default.default.string,
  id: function id(props, propName, componentName) {
    if (props['isLinkable'] && !props[propName]) {
      return new Error('id prop is required if isLinkable prop is true');
    }
    if (props[propName] && typeof props[propName] !== 'string') {
      return new Error("Invalid prop id of type '".concat(_typeof.default(props[propName]), "' supplied to '").concat(componentName, "', expected 'string' "));
    }
  },
  isLinkable: PropTypes__default.default.bool,
  link: PropTypes__default.default.string,
  linkText: PropTypes__default.default.string,
  pageSize: PropTypes__default.default.number
};

exports.OpenPositions = OpenPositions;
exports.default = OpenPositions;
//# sourceMappingURL=OpenPositions.js.map
